module.exports = __webpack_public_path__ + "columnists/bg-5cc9c82ee486e4b58594de644c311eea.png";